<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Gráficos y Estadísticas
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Informe por envase</h2>
    <a routerLink="/container-report-general" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <div *ngIf="header">
      <h3 class="text-primary-700 text-xl">{{ header?.container?.containerType?.name }} #{{ header?.container?.nroSerie }}</h3>

      <!-- Tabla para dispositivos de tamaño medio y grande -->
      <table class="table table-report-info w-full mb-4 hidden md:table text-sm">
        <tbody> <!-- Agregando tbody -->
          <tr>
            <th>Propietario:</th>
            <td>{{ header?.container?.client?.razonSocial }}</td>
            <th>Cliente:</th>
            <td>{{ header?.container?.client?.razonSocial }}</td>
          </tr>
          <tr>
            <th>Estado:</th>
            <td>{{ header?.status }}</td>
            <th>Fecha de mantención:</th>
            <td>{{ header?.fechaMantencion | date:'dd-MM-yyyy' }}</td>
          </tr>
          <tr>
            <th>Realizado por:</th>
            <td></td>
            <th>Inspeccionado por:</th>
            <td></td>
          </tr>
        </tbody> <!-- Cerrando tbody -->
      </table>

      <!-- Tabla para dispositivos de tamaño pequeño -->
      <table class="table table-report-info w-full mb-4 md:hidden">
        <tbody> <!-- Agregando tbody -->
          <tr>
            <th>Propietario:</th>
            <td>{{ header?.container?.client?.razonSocial }}</td>
          </tr>
          <tr>
            <th>Cliente:</th>
            <td>{{ header?.container?.client?.razonSocial }}</td>
          </tr>
          <tr>
            <th>Estado:</th>
            <td>{{ header?.status }}</td>
          </tr>
          <tr>
            <th>Fecha de mantención:</th>
            <td>{{ header?.fechaMantencion | date:'dd-MM-yyyy' }}</td>
          </tr>
          <tr>
            <th>Realizado por:</th>
            <td></td>
          </tr>
          <tr>
            <th>Inspeccionado por:</th>
            <td></td>
          </tr>
        </tbody> <!-- Cerrando tbody -->
      </table>
    </div>

    <div *ngFor="let event of events; let i = index" class="accordion accordion-report mb-2" [class.active]="expandedEventIndex === i">
      <div class="accordion-trigger">
        <button 
          (click)="toggleEventDetails(i)" 
          type="button" 
          [attr.aria-expanded]="expandedEventIndex === i ? 'true' : 'false'"
          [attr.aria-controls]="'accordion_item' + i">
          {{ event?.title }} ({{ event?.timestamp | date:'dd-MM-yyyy' }})
          <span class="circle circle-sm bg-primary-500">
            <i class="fas text-white" [class]="expandedEventIndex === i ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="accordion-content" [attr.id]="'accordion_item' + i">
        <div class="flex flex-wrap">
      <!-- THUMBNAILS -->
      <ng-container *ngIf="event.image?.length; else noImg">
        <div *ngFor="let img of event.image"
             class="w-24 h-24 mr-4 mb-2 bg-center bg-cover rounded-md shadow"
             [style.background-image]="'url(' + img + ')'">
        </div>
      </ng-container>
      <ng-template #noImg>
        <p class="italic text-gray-500 mr-4 mb-2">Sin fotos</p>
      </ng-template>

      <!-- INFO -->
      <div class="flex-1 min-w-[200px]">
        <p><strong class="text-primary-500">Estado:</strong> {{ event.state }}</p>
        <p><strong class="text-primary-500">Observaciones:</strong><br>{{ event.observations }}</p>
      </div>
    </div>
      </div>
    </div>

    <div class="flex justify-end mt-4">
      <button class="button button-danger" (click)="exportPdf()">Exportar PDF</button>
    </div>
  </div>
</div>
